import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@topconagriculture/modal';
import { transition } from '@topconagriculture/theme';
import { MorePopover } from '@topconagriculture/react-components';
import { makeStyles } from '@material-ui/core/styles';
import { useWidgetDeleteMutation } from '../../../hooks';
import { useDashboardConfig } from '../../../hooks';
const useStyles = makeStyles((theme) => ({
    header: {
        position: 'relative',
        width: '100%',
        height: 35,
        padding: '0px 10px',
        color: '#333333',
        borderBottom: '1px solid #CCCCCC',
        transition: transition(100),
        fontSize: theme.font.size.mediumBig,
        lineHeight: '35px',
        '&:hover': {
            backgroundColor: theme.color.grey.lightest,
            cursor: 'move',
        },
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-between',
    },
    moreButtonContainer: {
        display: 'block',
    },
    moreMenuItem: {
        height: 40,
        width: '100%',
        padding: 10,
        color: theme.color.font.light,
        fontSize: 14,
        cursor: 'pointer',
        backgroundColor: 'transparent',
    },
    title: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
}));
const WidgetHeader = ({ widget }) => {
    const classes = useStyles();
    const { header } = widget;
    const { t } = useTranslation();
    const dashboardConfig = useDashboardConfig();
    const deleteWidget = useWidgetDeleteMutation();
    const { dispatchOpenModal: openModal } = useModal();
    const headerConfig = header instanceof Function ? header(dashboardConfig) : header;
    const actions = (headerConfig === null || headerConfig === void 0 ? void 0 : headerConfig.actions) || [];
    const remove = () => {
        deleteWidget.mutate(widget.uuid);
    };
    return (React.createElement("header", { className: `${classes.header} widget-header` },
        React.createElement("span", { className: classes.title }, t(widget.title)),
        React.createElement(MorePopover, { labelButton: "", classes: { buttonContainer: classes.moreButtonContainer }, iconSize: 16 },
            actions.map((action) => (React.createElement("div", { key: action.title, className: classes.moreMenuItem, onClick: () => openModal({
                    modalName: action.modal,
                    modalParams: { widget },
                }) }, t(action.title)))),
            React.createElement("div", { className: classes.moreMenuItem, onClick: remove }, t('widget:remove_action')))));
};
export default WidgetHeader;
//# sourceMappingURL=WidgetHeader.js.map